import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import pathToRegexp from 'path-to-regexp/index';
export var getEnvironmentName = function getEnvironmentName() {
  var hostname = window.location.hostname;
  var environment = 'UNKNOWN';

  if (hostname) {
    var splitHostname = hostname.split('.'); // check for localhost

    if (splitHostname.length === 1) {
      var _splitHostname = _slicedToArray(splitHostname, 1);

      environment = _splitHostname[0];
    } else {
      var topLevelName = splitHostname[0].split('-'); // check for prod

      if (topLevelName.length === 1) {
        environment = null;
      } else if (topLevelName.length > 1) {
        var _topLevelName = _slicedToArray(topLevelName, 2);

        environment = _topLevelName[1];
      }
    }
  }

  return environment;
};
export var locationInPath = function locationInPath(location, path) {
  var re = pathToRegexp(path);
  return !!re.exec(location);
};
export default {
  getEnvironmentName: getEnvironmentName,
  locationInPath: locationInPath
};